import React from 'react';
import { Grid } from '@mui/material';
import MentionEditor from '../TextEditor/MentionEditor';
import useUpdateDatabaseRecordStore from './useUpdateDatabaseRecordStore';
import TextIcon from '../Component/Icons/TextIcon';
import NumberIcon from '../Component/Icons/NumberIcon';
import BooleanIcon from '../Component/Icons/BooleanIcon';
import DatetimeIcon from '../Component/Icons/DatetimeIcon';
import ListIcon from '../Component/Icons/ListIcon';

const ItemCell = (props) => {
  const { column, availablePlaceholders, index, columns } = props;
  const placeholders = useUpdateDatabaseRecordStore(s => s.placeholders);
  const position = useUpdateDatabaseRecordStore(s => s.position);

  const updateColumn = (idx, value, cols) => {
    let aData = cols[idx];
    aData.content = value;
    useUpdateDatabaseRecordStore.getState().setData(cols);
  };

  const getColumnType = type => {
    switch (type) {
      case 'VARCHAR2':
        return <TextIcon />;
      case 'DECIMAL':
        return <NumberIcon />;
      case 'BOOLEAN':
        return <BooleanIcon />;
      case 'DATETIME':
        return <DatetimeIcon />;
      case 'LIST':
        return <ListIcon />;
    }
  };

  let keyArray = [];
  if (position == index) {
    keyArray = placeholders;
  }

  return (
    <Grid item xs={12} style={{ margin: '4px 0px 4px 8px' }}>
      <Grid item xs={12} style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
        <Grid style={{ marginRight: 8 }}>{getColumnType(column.type)}</Grid>
        {column.columnName}
      </Grid>
      <MentionEditor
        style={{ width: '100%', marginBottom: 16, verticalAlign: 'top' }}
        availablePlaceholders={availablePlaceholders}
        placeholders={keyArray}
        text={column.content}
        placeholder="Type something or insert a placeholder"
        onChange={value => {
          updateColumn(index, value, columns);
        }}
        onFocus={e => {
          useUpdateDatabaseRecordStore.getState().setFocus(index, 'placeholder');
        }}
      />
    </Grid>
  );
};

export default ItemCell;
